import { useState } from 'react';
import _ from 'lodash';

const MULTIPLE_SELECTION_KEY = 'multipleSelection';

const setStorageMultiSelection = (multiSelectionStorageId, value) => {
  localStorage.setItem(multiSelectionStorageId, JSON.stringify(value));
};

const getStorageMultiSelection = (currentOrderId, multiSelectionStorageId) => {
  const multiSelectFromStorage = localStorage.getItem(multiSelectionStorageId);
  return { multiSelectFromStorage, multiSelectionStorageId };
};

const UseStateForMultipleSelection = (multiSelectFromStorage) => useState(
  multiSelectFromStorage ? JSON.parse(multiSelectFromStorage) : [],
);

export const MultiSelectItemsForOrder = (currentOrder) => {
  const currentOrderId = _.get(currentOrder, 'doc.id');
  const multiSelectionStorageId = `${currentOrderId}${MULTIPLE_SELECTION_KEY}`;

  const { multiSelectFromStorage } = getStorageMultiSelection(
    currentOrderId,
    multiSelectionStorageId,
  );

  const [get, set] = UseStateForMultipleSelection(multiSelectFromStorage);

  const setMultiSelectItems = (value) => {
    set(value);
    setStorageMultiSelection(multiSelectionStorageId, value);
  };

  return {
    setMultiSelectItems,
    multiSelectItems: get,
  };
};
